import { Box, ButtonNew as Button, Icon, IconOptions, Spacer, Text, TextProps } from '@jfs/ui-new'

interface AepsButtonProps {
  title: string
  onPress: any
  disabled?: boolean
  isLoading?: boolean
  iconId?: IconOptions
  borderRadius?: number
}

export const AepsButton = ({ title, onPress, disabled, isLoading, iconId, borderRadius }: AepsButtonProps) => {
  return (
    <Button
      title={title}
      type={'primaryFullWidth'}
      height={48}
      testID="tnx-button"
      onPress={onPress}
      disabled={disabled}
      isLoading={isLoading}
      color={'PRIMARY'}
      borderRadius={borderRadius}
      underlayColor={'PRIMARY'}
      hoverColor={'PRIMARY'}
      children={
        <Box flexDirection={'row'} alignItems={'center'}>
          {iconId && (
            <>
              <Icon id={iconId} size={20} color="WHITE" />
              <Spacer direction="horizontal" size={8} />
            </>
          )}
          <Text {...styles.title}>{title}</Text>
        </Box>
      }
    />
  )
}

const styles = {
  title: {
    fontFamily: 'jioType-medium',
    fontSize: 14,
    color: 'WHITE',
  } as TextProps,
}
